// extracted by mini-css-extract-plugin
export default {"card":"Success_card__ZQzk2","inner_card":"Success_inner_card__Twmxk"};